function ProfessionalLetterIcon() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 18.13 14.3">
            <g>
                <path
                    fill="#ffffff"
                    d="M5.28,17a.66.66,0,0,1-.66-.66V14.91H1.82a.75.75,0,0,1-.74-.75V3.73A.74.74,0,0,1,1.82,3h8.62a.75.75,0,0,1,.75.74V10.8h7.07a.67.67,0,0,1,.66.66v4.89a.66.66,0,0,1-.66.66Zm-.09-.66a.09.09,0,0,0,.09.09h13a.09.09,0,0,0,.09-.09v-4.8l-6.48,2.62-.1,0h0l-.1,0L11.19,14v.18a.75.75,0,0,1-.75.74H5.19ZM1.82,3.61a.13.13,0,0,0-.13.13V14.16a.13.13,0,0,0,.13.13h8.62a.13.13,0,0,0,.13-.13V3.73a.12.12,0,0,0-.13-.12Zm10,10,5.47-2.22h-6v2Z"
                    transform="translate(-0.94 -2.85)"
                />
                <path
                    fill="#ffffff"
                    d="M10.44,3.13a.61.61,0,0,1,.61.6v7.21h7.21a.53.53,0,0,1,.53.52v4.89a.52.52,0,0,1-.53.52h-13a.52.52,0,0,1-.52-.52V14.77H1.82a.62.62,0,0,1-.61-.61V3.73a.61.61,0,0,1,.61-.6h8.62M1.82,14.43h8.62a.27.27,0,0,0,.27-.27V3.73a.27.27,0,0,0-.27-.26H1.82a.26.26,0,0,0-.26.26V14.16a.27.27,0,0,0,.26.27m10-.68L18,11.24h-6.9v2.21l.72.3m0,.31h-.06l-.66-.27v.39a.62.62,0,0,1-.61.61H5.06v1.58a.22.22,0,0,0,.22.22h13a.22.22,0,0,0,.23-.22V11.46a.23.23,0,0,0,0-.11h0L11.83,14h-.06M10.44,2.85H1.82a.89.89,0,0,0-.88.88V14.16a.88.88,0,0,0,.88.88H4.48v1.31a.8.8,0,0,0,.8.8h13a.8.8,0,0,0,.8-.8V11.46a.79.79,0,0,0-.8-.79H11.32V3.73a.88.88,0,0,0-.88-.88ZM1.83,14.15V3.73h8.61V14.16Zm9.49-.88V11.52h5.21l-4.76,1.93-.45-.18Zm.53,1.05h0l0,0,6.29-2.55V16.3H5.33V15h5.11a.88.88,0,0,0,.88-.85l.28.11h.25Z"
                    transform="translate(-0.94 -2.85)"
                />
            </g>
            <path
                fill="#ffffff"
                d="M7.81,5H9.39a.11.11,0,0,0,.11-.11.1.1,0,0,0-.11-.1H7.81a.1.1,0,0,0-.11.1A.11.11,0,0,0,7.81,5Z"
                transform="translate(-0.94 -2.85)"
            />
            <path
                fill="#ffffff"
                d="M2.87,8.48H9.39a.11.11,0,0,0,.11-.11.1.1,0,0,0-.11-.1H2.87a.1.1,0,0,0-.11.1A.11.11,0,0,0,2.87,8.48Z"
                transform="translate(-0.94 -2.85)"
            />
            <path
                fill="#ffffff"
                d="M2.87,9.63H9.39a.11.11,0,0,0,.11-.11.11.11,0,0,0-.11-.1H2.87a.11.11,0,0,0-.11.1A.11.11,0,0,0,2.87,9.63Z"
                transform="translate(-0.94 -2.85)"
            />
            <path
                fill="#ffffff"
                d="M2.87,10.78H9.39a.1.1,0,0,0,.11-.1.11.11,0,0,0-.11-.11H2.87a.11.11,0,0,0-.11.11A.1.1,0,0,0,2.87,10.78Z"
                transform="translate(-0.94 -2.85)"
            />
            <path
                fill="#ffffff"
                d="M6.51,11.94H9.39a.11.11,0,0,0,.11-.11.1.1,0,0,0-.11-.1H2.87a.1.1,0,0,0-.11.1.11.11,0,0,0,.11.11Z"
                transform="translate(-0.94 -2.85)"
            />
            <path
                fill="#ffffff"
                d="M2.87,7.32H4.45a.1.1,0,0,0,.11-.1.11.11,0,0,0-.11-.11H2.87a.11.11,0,0,0-.11.11A.1.1,0,0,0,2.87,7.32Z"
                transform="translate(-0.94 -2.85)"
            />
        </svg>
    )
}

export default ProfessionalLetterIcon
